import { useNavigate } from 'react-router-dom';
import { useCallback, useRef, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getTrendyolOrders } from '../../api/Trendyol';
import { sharedStyles } from '../../utils/Style';
import { ScanBarcode } from '../../components/Barcode/ScanBarcode';
import { Waiting } from '../../components/Waiting/Waiting';

export const ScanTrendyolOrderBarcodePage = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const lastScanRef = useRef('');

  const goBack = useCallback(() => navigate('/sales/trendyol'), [navigate]);

  const onScan = useCallback(
    (barcode: string) => {
      if (lastScanRef.current === barcode) return;
      lastScanRef.current = barcode;

      setLoading(true);

      getTrendyolOrders({
        cargoTrackingNumber: barcode,
        pagination: { page: 0, pageSize: 1 },
      })
        .then((orders) => {
          if (orders.data.length > 0) {
            navigate(`/sales/trendyol/${orders.data[0].trendyolID}/collect`);
          } else {
            toast.error('Okutulan barkoda ait bir sipariş kaydı bulunamadı.');
          }
        })
        .catch((err) => toast.error(err.message))
        .finally(() => {
          setLoading(false);
        });
    },
    [loading],
  );

  return (
    <Box sx={{ ...sharedStyles.pageBody, gap: 1.5 }}>
      <Waiting open={loading} />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          flexWrap: 'wrap',
          mb: 3,
          gap: 1.5,
        }}
      >
        <IconButton onClick={goBack} sx={{ ...sharedStyles.backIcon }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant='h5'>Trendyol Barkodu Tara</Typography>
      </Box>

      <ScanBarcode onScan={onScan} onCancel={goBack} />
    </Box>
  );
};
